import { ICompDevEvaluationContext, compDevEvaluationContext } from "./context";
import { useContext } from "react";

export const useCompDevEvaluationContext = (): ICompDevEvaluationContext | null => {
    const contextValue = useContext(compDevEvaluationContext);

    return contextValue;
};
